import { render, staticRenderFns } from "./MessageTimestamp.vue?vue&type=template&id=35c5ef86&scoped=true&"
import script from "./MessageTimestamp.vue?vue&type=script&lang=js&"
export * from "./MessageTimestamp.vue?vue&type=script&lang=js&"
import style0 from "./MessageTimestamp.vue?vue&type=style&index=0&id=35c5ef86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5ef86",
  null
  
)

export default component.exports